(function () {
  let docObserver;
  let gridObserver;
  let activeGrid = null;
  let debounceTimer = null;
  let running = false;

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', scheduleRun);
  document.addEventListener('shopify:section:reorder', scheduleRun);

  function boot() {
    observeDocumentForGridChanges();
    scheduleRun();
  }

  function scheduleRun() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(run, 100);
  }

  function observeDocumentForGridChanges() {
    if (docObserver) return;

    
    docObserver = new MutationObserver(() => scheduleRun());
    docObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  function observeGrid(grid) {
    if (activeGrid === grid) return;

    if (gridObserver) gridObserver.disconnect();
    activeGrid = grid;

   
    gridObserver = new MutationObserver(() => scheduleRun());
    gridObserver.observe(grid, { childList: true });
  }

  function run() {
    if (running) return;
    running = true;

    try {
      const grid = findGrid();
      const promoHtml = getPromoHtml();

      if (!grid || !promoHtml) return;

      observeGrid(grid);
      syncPromoTiles(grid, promoHtml);
    } finally {
      running = false;
    }
  }

  function getPromoHtml() {
    const t = document.querySelector('#promo-tile-template');
    if (!t) return '';


    return (t.tagName === 'TEMPLATE' ? t.innerHTML : t.innerHTML).trim();
  }

  function findGrid() {
    return (
      document.querySelector('.globo-products-grid') ||
      document.querySelector('#product-grid') ||
      document.querySelector('.product-grid') ||
      document.querySelector('ul.grid')
    );
  }

  function getProductItems(grid) {
    const children = Array.from(grid.children).filter((el) => {
      if (!(el instanceof HTMLElement)) return false;
      if (el.matches('[data-promo-wrapper="true"]')) return false;
      if (el.id === 'promo-tile-template') return false; 
      return true;
    });

 
    if (children.length === 0) {
      const nested = grid.querySelectorAll(':scope .grid__item, :scope li.grid__item, :scope [data-product-id], :scope .product-grid__item');
      return Array.from(nested).filter((el) => el instanceof HTMLElement && !el.closest('[data-promo-wrapper="true"]'));
    }

    return children;
  }

  function desiredSlots(productCount) {
    if (productCount <= 0) return [];
    if (productCount < 7) return [productCount - 1];

    const slots = [];
    for (let i = 6; i < productCount; i += 7) slots.push(i);
    return slots;
  }

  function syncPromoTiles(grid, promoHtml) {
    const products = getProductItems(grid);
    if (!products.length) return;

    const slots = desiredSlots(products.length);
    const validSlots = new Set(slots.map(String));


    const existing = new Map();
    grid.querySelectorAll('[data-promo-wrapper="true"][data-promo-slot]').forEach((n) => {
      existing.set(String(n.getAttribute('data-promo-slot')), n);
    });

    slots.forEach((slotIndex) => {
      const slotKey = String(slotIndex);
      if (existing.has(slotKey)) return;

      const anchor = products[slotIndex];
      if (!anchor) return;

      const wrapperTag = (grid.tagName === 'UL' || grid.tagName === 'OL') ? 'li' : 'div';
      const node = document.createElement(wrapperTag);

      node.setAttribute('data-promo-wrapper', 'true');
      node.setAttribute('data-promo-slot', slotKey);


      node.className = (anchor.className ? anchor.className + ' ' : '') + 'promo-tile-item';

      node.innerHTML = promoHtml;
      node.style.pointerEvents = 'auto';

      anchor.insertAdjacentElement('afterend', node);
    });

  
    grid.querySelectorAll('[data-promo-wrapper="true"]').forEach((node) => {
      const slot = node.getAttribute('data-promo-slot');
      if (!slot || !validSlots.has(String(slot))) node.remove();
    });
  }
})();